export default __webpack_public_path__ + "static/media/kids.1be5f520.jpg";